import React, { useState, useEffect } from 'react';
import ContactFormCT from '../../../components/common/ContactFormCT';

const HeroSection = () => {
  const [deadlineInfo, setDeadlineInfo] = useState({
    daysLeft: 0,
    dueDate: '',
    dueYear: '',
    rawDays: 0
  });

  useEffect(() => {
    const calculateDeadline = () => {
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      let y = now.getFullYear();
      let target = new Date(y, 8, 30); // 8 is September (0-indexed)

      if (target < today) {
        y += 1;
        target = new Date(y, 8, 30);
      }

      const diffTime = target.getTime() - today.getTime();
      const days = Math.round(diffTime / (1000 * 60 * 60 * 24));

      setDeadlineInfo({
        daysLeft: days,
        dueDate: `30 September ${y}`,
        dueYear: `FY${y - 1}`,
        rawDays: days
      });
    };

    calculateDeadline();
  }, []);

  const getDaysString = () => {
    if (deadlineInfo.rawDays === 0) {
      return 'due today';
    } else if (deadlineInfo.rawDays === 1) {
      return '1 day left';
    } else {
      return `${deadlineInfo.daysLeft} days left`;
    }
  };

  return (
    <section className="hero">
      <div className="hero-bg">
        <img
          src="https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=2000&q=70"
          alt=""
          aria-hidden="true"
          fetchPriority="high"
          width="2000"
          height="1333"
        />
      </div>
      <div className="shell">
        <div className="hero-inner">
          <div className="hero-title-group">
            <p
              className="deadline"
              title="Deadline shown is for a 31 December financial year end. Other year ends fall due nine months after their own year end."
            >
              <span className="dot" aria-hidden="true"></span>
              <span>
                <span id="dlYear">{deadlineInfo.dueYear}</span> returns are due{' '}
                <b id="dlDate">{deadlineInfo.dueDate}</b>{' '}
                <span style={{ opacity: 0.8 }}>for a 31 December year end</span>
              </span>
              <span aria-hidden="true" style={{ opacity: 0.4 }}>
                |
              </span>
              <b>
                <span id="daysLeft">{getDaysString()}</span>
              </b>
            </p>

            <h1 className="h1">UAE Corporate Tax registration and return filing, Dubai</h1>
          </div>

          <ul className="hero-points">
            <li>
              <svg width="19" height="19" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <circle cx="12" cy="12" r="11" fill="rgba(205,152,48,.20)" />
                <path d="M7.5 12.4l3 3 6-6.4" stroke="#e2b350" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <span>
                <b>Fixed fee, quoted in writing before any work starts.</b> No hourly billing.
              </span>
            </li>
            <li>
              <svg width="19" height="19" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <circle cx="12" cy="12" r="11" fill="rgba(205,152,48,.20)" />
                <path d="M7.5 12.4l3 3 6-6.4" stroke="#e2b350" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <span>
                <b>We file on EmaraTax, you do not.</b> One document list, then we handle the portal.
              </span>
            </li>
            <li>
              <svg width="19" height="19" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <circle cx="12" cy="12" r="11" fill="rgba(205,152,48,.20)" />
                <path d="M7.5 12.4l3 3 6-6.4" stroke="#e2b350" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <span>
                <b>25 years of UAE filings.</b> Members of the Emirates Association for Accountants and Auditors.
              </span>
            </li>
          </ul>

          <div className="form-card" id="book">
            <div className="form-card__head">
              <h2>Book a free review</h2>
              <p>A 20-minute call. We tell you what you must file, when it is due, and what it will cost.</p>
            </div>
            <div className="form-card__body">
              <ContactFormCT formId="heroForm" isModal={false} />
            </div>
          </div>

          <div className="definition">
            <p>
              <b>Standard Auditing</b> is a Dubai audit and tax firm that handles UAE Corporate Tax registration and
              return filing for mainland and free zone companies. We confirm whether you can elect Small Business
              Relief, prepare the return, and submit it on the EmaraTax portal for a fixed fee of <b>AED 750</b> or{' '}
              <b>AED 1,500</b> plus VAT.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
